<template>
  <!-- eslint-disable -->
  <div class="pointer" v-bind:style="{color: color}">
    <div
      class="pointer__marker"
      v-bind:style="{transform: 'translate(-50%,-50%) rotate(' + position * 380 + 'deg)'}"
    ></div>
  </div>
</template>

<script>
/*eslint-disable */
export default {
  name: 'Bg',
  props: {
    position: Number,
    color: String
  }
};
</script>

